import classNames from 'classnames';
import { type ComponentProps, memo } from 'react';

import { Close as CloseIcon } from '@air/next-icons';
import { VisuallyHidden } from '@air/primitive-visually-hidden';

export type AlertModalCloseButtonProps = ComponentProps<'button'>;

export const AlertModalCloseButton = memo(({ className, ...restOfProps }: AlertModalCloseButtonProps) => {
  return (
    <button
      className={classNames(
        'flex h-6 w-6 items-center justify-center rounded-4 border-0 bg-transparent text-grey-12 outline-none hover:bg-grey-4 focus-visible:ring-2 focus-visible:ring-blue-9 active:bg-grey-4',
        className,
      )}
      {...restOfProps}
    >
      <VisuallyHidden>Close modal</VisuallyHidden>
      <CloseIcon className="size-4" />
    </button>
  );
});

AlertModalCloseButton.displayName = 'AlertModalCloseButton';
